import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  connect () {
    this.element.addEventListener('toggle', this.sync)
    this.form = this.element.closest('form')
    if (this.form) this.form.addEventListener('submit', this.sync)
    this.sync()
  }

  disconnect () {
    this.element.removeEventListener('toggle', this.sync)
    if (this.form) this.form.removeEventListener('submit', this.sync)
  }

  sync = () => {
    if (this.hasInputTarget) this.inputTarget.disabled = !this.element.open
  }
}
